import {Locale} from '../locale';
import {nativeLanguageByLocale} from '../nativeLanguageByLocale';
import {
  ASSETS_URL_DESKTOP_PREVIEW,
  ASSETS_URL_MOBILE_PREVIEW,
  IRIS_URL_PREVIEW,
  KLARNA_SDK_URL_STAGING,
  getDesktopHelpCenterEndpointByLocale,
} from './constants';
import {HttpUrl, UrlMapping} from './types';

const desktopHelpCenterEndpointByLocale =
  getDesktopHelpCenterEndpointByLocale(IRIS_URL_PREVIEW);

const sendSmsEndpoint = `${IRIS_URL_PREVIEW}/sms` as HttpUrl;

export const preview: UrlMapping<'preview'> = {
  [Locale.en_ZZ]: {
    environment: 'preview',
    locale: Locale.en_ZZ,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://es-preview.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-preview.aboutyou.com',
        publicDesktopHostname: 'www-preview.aboutyou.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://m-es-preview.aboutyou.com',
            alternateDomainUrl: 'https://es-preview.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ZZ]: {
    environment: 'preview',
    locale: Locale.es_ZZ,
    urlSets: [
      {
        hostname: 'es-preview.aboutyou.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-es.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://www-preview.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-es-preview.aboutyou.com',
        publicDesktopHostname: 'es-preview.aboutyou.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-es.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://m-preview.aboutyou.com',
            alternateDomainUrl: 'https://www-preview.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_DE]: {
    environment: 'preview',
    locale: Locale.de_DE,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://en-preview.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
      {
        hostname: 'm-preview.aboutyou.de',
        publicDesktopHostname: 'www-preview.aboutyou.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://m-en-preview.aboutyou.de',
            alternateDomainUrl: 'https://en-preview.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_DE]: {
    environment: 'preview',
    locale: Locale.en_DE,
    urlSets: [
      {
        hostname: 'en-preview.aboutyou.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-en.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://www-preview.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
      {
        hostname: 'm-en-preview.aboutyou.de',
        publicDesktopHostname: 'en-preview.aboutyou.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-en.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://m-preview.aboutyou.de',
            alternateDomainUrl: 'https://www-preview.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_AT]: {
    environment: 'preview',
    locale: Locale.de_AT,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://en-preview.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm-preview.aboutyou.at',
        publicDesktopHostname: 'www-preview.aboutyou.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://m-en-preview.aboutyou.at',
            alternateDomainUrl: 'https://en-preview.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_AT]: {
    environment: 'preview',
    locale: Locale.en_AT,
    urlSets: [
      {
        hostname: 'en-preview.aboutyou.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-en.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://www-preview.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm-en-preview.aboutyou.at',
        publicDesktopHostname: 'en-preview.aboutyou.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-en.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://m-preview.aboutyou.at',
            alternateDomainUrl: 'https://www-preview.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_CH]: {
    environment: 'preview',
    locale: Locale.de_CH,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm-preview.aboutyou.ch',
        publicDesktopHostname: 'www-preview.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr-preview.aboutyou.ch',
            alternateDomainUrl: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it-preview.aboutyou.ch',
            alternateDomainUrl: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en-preview.aboutyou.ch',
            alternateDomainUrl: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_CH]: {
    environment: 'preview',
    locale: Locale.fr_CH,
    urlSets: [
      {
        hostname: 'fr-preview.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-fr.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
      {
        hostname: 'm-fr-preview.aboutyou.ch',
        publicDesktopHostname: 'fr-preview.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-fr.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m-preview.aboutyou.ch',
            alternateDomainUrl: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it-preview.aboutyou.ch',
            alternateDomainUrl: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en-preview.aboutyou.ch',
            alternateDomainUrl: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_CH]: {
    environment: 'preview',
    locale: Locale.it_CH,
    urlSets: [
      {
        hostname: 'it-preview.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-it.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
      {
        hostname: 'm-it-preview.aboutyou.ch',
        publicDesktopHostname: 'it-preview.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-it.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m-preview.aboutyou.ch',
            alternateDomainUrl: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr-preview.aboutyou.ch',
            alternateDomainUrl: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en-preview.aboutyou.ch',
            alternateDomainUrl: 'https://en-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_CH]: {
    environment: 'preview',
    locale: Locale.en_CH,
    urlSets: [
      {
        hostname: 'en-preview.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-en.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm-en-preview.aboutyou.ch',
        publicDesktopHostname: 'en-preview.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-en.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m-preview.aboutyou.ch',
            alternateDomainUrl: 'https://www-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr-preview.aboutyou.ch',
            alternateDomainUrl: 'https://fr-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it-preview.aboutyou.ch',
            alternateDomainUrl: 'https://it-preview.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_NL]: {
    environment: 'preview',
    locale: Locale.nl_NL,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://en-preview.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
      {
        hostname: 'm-preview.aboutyou.nl',
        publicDesktopHostname: 'www-preview.aboutyou.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://m-en-preview.aboutyou.nl',
            alternateDomainUrl: 'https://en-preview.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_NL]: {
    environment: 'preview',
    locale: Locale.en_NL,
    urlSets: [
      {
        hostname: 'en-preview.aboutyou.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-en.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://www-preview.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
      {
        hostname: 'm-en-preview.aboutyou.nl',
        publicDesktopHostname: 'en-preview.aboutyou.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-en.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://m-preview.aboutyou.nl',
            alternateDomainUrl: 'https://www-preview.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pl_PL]: {
    environment: 'preview',
    locale: Locale.pl_PL,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.pl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
      {
        hostname: 'm-preview.aboutyou.pl',
        publicDesktopHostname: 'www-preview.aboutyou.pl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.cs_CZ]: {
    environment: 'preview',
    locale: Locale.cs_CZ,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.cz',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
      {
        hostname: 'm-preview.aboutyou.cz',
        publicDesktopHostname: 'www-preview.aboutyou.cz',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_BE]: {
    environment: 'preview',
    locale: Locale.nl_BE,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://fr-preview.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
      {
        hostname: 'm-preview.aboutyou.be',
        publicDesktopHostname: 'www-preview.aboutyou.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://m-fr-preview.aboutyou.be',
            alternateDomainUrl: 'https://fr-preview.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_BE]: {
    environment: 'preview',
    locale: Locale.fr_BE,
    urlSets: [
      {
        hostname: 'fr-preview.aboutyou.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-fr.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://www-preview.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
      {
        hostname: 'm-fr-preview.aboutyou.be',
        publicDesktopHostname: 'fr-preview.aboutyou.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-fr.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://m-preview.aboutyou.be',
            alternateDomainUrl: 'https://www-preview.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ro_RO]: {
    environment: 'preview',
    locale: Locale.ro_RO,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.ro',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
      {
        hostname: 'm-preview.aboutyou.ro',
        publicDesktopHostname: 'www-preview.aboutyou.ro',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hu_HU]: {
    environment: 'preview',
    locale: Locale.hu_HU,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.hu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
      {
        hostname: 'm-preview.aboutyou.hu',
        publicDesktopHostname: 'www-preview.aboutyou.hu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sk_SK]: {
    environment: 'preview',
    locale: Locale.sk_SK,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.sk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
      {
        hostname: 'm-preview.aboutyou.sk',
        publicDesktopHostname: 'www-preview.aboutyou.sk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sl_SI]: {
    environment: 'preview',
    locale: Locale.sl_SI,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.si',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
      {
        hostname: 'm-preview.aboutyou.si',
        publicDesktopHostname: 'www-preview.aboutyou.si',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lv_LV]: {
    environment: 'preview',
    locale: Locale.lv_LV,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://ru-preview.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm-preview.aboutyou.lv',
        publicDesktopHostname: 'www-preview.aboutyou.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://m-ru-preview.aboutyou.lv',
            alternateDomainUrl: 'https://ru-preview.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_LV]: {
    environment: 'preview',
    locale: Locale.ru_LV,
    urlSets: [
      {
        hostname: 'ru-preview.aboutyou.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-ru.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://www-preview.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm-ru-preview.aboutyou.lv',
        publicDesktopHostname: 'ru-preview.aboutyou.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-ru.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://m-preview.aboutyou.lv',
            alternateDomainUrl: 'https://www-preview.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lt_LT]: {
    environment: 'preview',
    locale: Locale.lt_LT,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.lt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
      {
        hostname: 'm-preview.aboutyou.lt',
        publicDesktopHostname: 'www-preview.aboutyou.lt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.et_EE]: {
    environment: 'preview',
    locale: Locale.et_EE,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://ru-preview.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm-preview.aboutyou.ee',
        publicDesktopHostname: 'www-preview.aboutyou.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://m-ru-preview.aboutyou.ee',
            alternateDomainUrl: 'https://ru-preview.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_EE]: {
    environment: 'preview',
    locale: Locale.ru_EE,
    urlSets: [
      {
        hostname: 'ru-preview.aboutyou.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout-ru.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://www-preview.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm-ru-preview.aboutyou.ee',
        publicDesktopHostname: 'ru-preview.aboutyou.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m-ru.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://m-preview.aboutyou.ee',
            alternateDomainUrl: 'https://www-preview.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hr_HR]: {
    environment: 'preview',
    locale: Locale.hr_HR,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.hr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
      {
        hostname: 'm-preview.aboutyou.hr',
        publicDesktopHostname: 'www-preview.aboutyou.hr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.bg_BG]: {
    environment: 'preview',
    locale: Locale.bg_BG,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.bg',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-preview.aboutyou.bg',
        publicDesktopHostname: 'www-preview.aboutyou.bg',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_FR]: {
    environment: 'preview',
    locale: Locale.fr_FR,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.fr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
      {
        hostname: 'm-preview.aboutyou.fr',
        publicDesktopHostname: 'www-preview.aboutyou.fr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.da_DK]: {
    environment: 'preview',
    locale: Locale.da_DK,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.dk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
      {
        hostname: 'm-preview.aboutyou.dk',
        publicDesktopHostname: 'www-preview.aboutyou.dk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sv_SE]: {
    environment: 'preview',
    locale: Locale.sv_SE,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.se',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
      {
        hostname: 'm-preview.aboutyou.se',
        publicDesktopHostname: 'www-preview.aboutyou.se',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fi_FI]: {
    environment: 'preview',
    locale: Locale.fi_FI,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.fi',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
      {
        hostname: 'm-preview.aboutyou.fi',
        publicDesktopHostname: 'www-preview.aboutyou.fi',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ES]: {
    environment: 'preview',
    locale: Locale.es_ES,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.es',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
      {
        hostname: 'm-preview.aboutyou.es',
        publicDesktopHostname: 'www-preview.aboutyou.es',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_IT]: {
    environment: 'preview',
    locale: Locale.it_IT,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.it',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
      {
        hostname: 'm-preview.aboutyou.it',
        publicDesktopHostname: 'www-preview.aboutyou.it',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pt_PT]: {
    environment: 'preview',
    locale: Locale.pt_PT,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.pt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
      {
        hostname: 'm-preview.aboutyou.pt',
        publicDesktopHostname: 'www-preview.aboutyou.pt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_GR]: {
    environment: 'preview',
    locale: Locale.el_GR,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.gr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-preview.aboutyou.gr',
        publicDesktopHostname: 'www-preview.aboutyou.gr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_CY]: {
    environment: 'preview',
    locale: Locale.el_CY,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.com.cy',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-preview.aboutyou.com.cy',
        publicDesktopHostname: 'www-preview.aboutyou.com.cy',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.fr_LU]: {
    environment: 'preview',
    locale: Locale.fr_LU,
    urlSets: [
      {
        hostname: 'www-preview.aboutyou.lu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PREVIEW,
        legacyCheckout: 'https://checkout.aboutyou.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
      {
        hostname: 'm-preview.aboutyou.lu',
        publicDesktopHostname: 'www-preview.aboutyou.lu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PREVIEW,
        legacyCheckout: 'https://checkout-m.aboutyou.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_STAGING,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-prev`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/staging`,
        checkoutTrackingUrl: 'https://cot.aboutyou-staging.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
    ],
    genderCookieSameDomain: true,
  },
};
